<d-card>
    <img src="../../../assets/images/signup.png" alt="">
    <h3>User Registration</h3>
    <div id="widget-root"></div>  
</d-card>

